// extracted by mini-css-extract-plugin
module.exports = {"w15d73cm":"w15d73cm","b4genuf":"b4genuf","b56px31":"b56px31","b1gw4f1b":"b1gw4f1b","oscillate-b1gw4f1b":"oscillate-b1gw4f1b","b1hsu63a":"b1hsu63a"};